import React from "react";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";
import SkadiColors from "../../skadiColors";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { green } from "@material-ui/core/colors";

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const useStyles = makeStyles((theme) => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: SkadiColors.warn,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: SkadiColors.info,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: "flex",
    alignItems: "center",
  },
}));

const SkadiSnackbar = (props) => {
  const classes = useStyles();
  const { className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={clsx(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={clsx(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>,
      ]}
      {...other}
    />
  );
};

export default SkadiSnackbar;

const ErrorBar = ({ error, setError }) => {
  const handleClose = () => setError(false);

  if (error === false) return <></>;

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      open={true}
      autoHideDuration={4000}
      onClose={handleClose}
    >
      <SkadiSnackbar variant="error" message={error} onClose={handleClose} />
    </Snackbar>
  );
};

export { ErrorBar };

const ErrorBarTimeout = ({ errorOriginal }) => {
  const [error, setError] = React.useState(errorOriginal);

  const handleClose = () => setError(false);

  if (error === false) return <></>;

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      open={true}
      autoHideDuration={4000}
      onClose={handleClose}
    >
      <SkadiSnackbar variant="error" message={error} onClose={handleClose} />
    </Snackbar>
  );
};

export { ErrorBarTimeout };
